<template>
<div style="min-height:100vh">
    <Sidebar v-if="appart"/>
    <Sidebar v-else title="Logis du Chateau" link="https://www.airbnb.fr/rooms/36438518" appartement="/logisduchateau"/>

    
    <div class="d-flex justify-content-center  flex-wrap">
        
            <panel text='Visites Culturelles' img='musee.png' url="Musées"/>
            <panel text='Randonnées Pédestres' img='marche.png' url="Marche"/>
            <panel text='Activités sportives' img='sport.png'/>
            <panel text='Restaurants' img='restaurant.png' url="Restaurants" />
       
            
    </div>
    
</div>
    
</template>

<script>
import Sidebar from '../components/Sidebar'
import panel from '../components/Panel-appartement'

export default {
    name : 'Gaillon',
    components : {
        Sidebar,
        panel,
     
    },
    metaInfo() {
        return { 
            title: "Ville de Gaillon - Que Faire ?",
            meta: [
                { name: 'description', content:  "Entre Rouen et Paris, la ville de Gaillon vous offre un large panel d'activités, culturelles, Gastronomique ou sportive , afin de vous ressourcer en plein air "},
                { property: 'og:title', content: "Ville de Gaillon - Location Normandie"},
                { property: 'og:site_name', content: 'Ville de Gaillon'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    },
    computed: {

        appart() {
            if(this.$route.params.appartement == "chateau") return false;
            return true
        },
        

    },
    props : {
    },
    beforeCreate: function() {
        document.body.className = 'gaillon';
    },
    created(){
    },
    methods : {
        widthW : function()
        {
            return window.innerWidth;
        }
    }
    
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
body {
    
    background-image: none!important;
    
}

.VueCarousel-wrapper{
    position: absolute!important;
   
    
}

div {
    font-family: 'Indie Flower', cursive;
    font-size: 20px;
}

</style>